<template>
  <div class="flex flex-col w-full">
    <div class="flex items-end" v-if="isNew">
      <div class="form-group flex-1">
        <div class="flex justify-center w-full mb-3">
          <div class="avatarBox cursor-pointer relative justify-center"> 
            <img :src="avatar" class="avatar" />
            <input type="file" ref="imageInput" class="file" accept="image/*" @change="imageChanged"/>
          </div>
        </div>
        <div class="flex">
          <label class="labelprofile mr-3 pt-1"><h4>{{ $t('nombreusuario') }}</h4></label>
          <input type="text" class="form-input" v-model="profile.name">
        </div>
        <div class="flex mt-2">
          <label class="labelprofile mr-3 pt-1"><h4>{{ $t('paisusuario') }}</h4></label>
          <select class="form-select pr-2" v-model="profile.country" :disabled="!isNew">
            <option disabled value="">{{ $t('registropaisseleccion') }}</option>
            <option v-for="country in items" :key="country.code" :value="country.code" >{{country.native}}</option>
          </select>
        </div>
        <div class="form-group flex-1 ml-4 items-center mt-2">
          <div class="flex justify-center">
            <label class="form-switch">
            <input type="checkbox" v-model="profile.isEnterprise" :disabled="!isNew">
            <i class="form-icon"></i> {{ $t('empresausuario') }}
          </label>
          </div>
        </div>
        <transition name="fade">
          <div class="flex" v-if="profile.isEnterprise">
            <label class="labelprofile mr-3 pt-1"><h4>{{ $t('perfilpaginaweb') }}</h4></label>
            <input type="text" class="form-input" v-model="profile.url">
          </div>
        </transition>      
      </div>
    </div>
    <div v-if="!isNew">
      <div class="flex items-end">
        <div class="form-group flex-1">
          <div class="flex justify-center w-full mb-4">
            <div class="avatarBox cursor-pointer relative justify-center"> 
              <img :src="avatar" class="avatar mr-4 " />
              <input type="file" ref="imageInput" class="file" accept="image/*" @change="imageChanged"/>
            </div>
          </div>
          <div class="flex">
            <label class="labelprofile mr-3 pt-1"><h4>{{ $t('nombreusuario') }}</h4></label>
            <input type="text" class="form-input" v-model="profile.name">
          </div>
          <div class="flex">
            <label class="labelprofile mr-3 pt-1"><h4>{{ $t('perfilcorreoelectronico') }}</h4></label>
            <input type="text" class="form-input" v-model="profile.newemail" :placeholder="profile.email" @click="formSelect = true">
          </div>
          <transition name="fade">
            <div class="mt-4 mb-3" v-show="formSelect">
              <label class="labelprofile"><center>{{ $t('perfiltextocontrasena') }}</center></label>
              <input type="password" class="form-input" v-model="profile.password" autocomplete="off">
            </div>
          </transition>
          <transition name="fade">
            <div class="flex" v-if="profile.isEnterprise" v-show="!formSelect">
              <label class="labelprofile mr-3 pt-1"><h4>{{ $t('perfilpaginaweb') }}</h4></label>
              <input type="text" class="form-input" v-model="profile.url" :placeholder="profile.url">
            </div>
          </transition>      
        </div>
      </div>
      <div class="form-group flex mt-3"  v-show="!formSelect">
          <div>
            {{ $t('paisusuario') }}:<b>{{'&nbsp;' + items[profile.country].name}}</b><br>
            <div v-if="!profile.isEnterprise">
              {{ $t('perfiltextoempresa') }}
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import firebase from '@/firebase'
import ImageUploaderCropper from '@/components/ImageUploaderCropper'
export default {
  name: 'ProfileEditor',
  props: {
    value: {
      type: Object,
      required: true
    },
    isNew: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      profile: null,
      width: 180,
      height: 180,
      formSelect: false
    }
  },
  computed: {
    ...mapState('countries', ['items']),
    avatar() {
      if (this.profile.image) {
        return this.profile.image
      } else {
        return require('@/assets/images/profile.svg')
      }
    }
  },
  methods: {
    async imageChanged(ev) {
      const file = ev.target.files[0];
      const ext = file.name.substr(file.name.lastIndexOf('.')+1,file.name.length);
      this.profile.ref =  firebase.storage.ref().child(`avatars/${this.profile.id}.${ext}`)

      const reader = new FileReader();

      reader.onload = async () => {
        let base64Image = await this.openCropper(reader.result)
        if (base64Image) {
          this.profile.base64Image = base64Image
          this.profile.image = base64Image
        }
        const input = this.$refs.imageInput;
        input.type = 'text';
        input.type = 'file';
      }
      reader.readAsDataURL(file)
    },
    openCropper (base64Image) {
      return this.$bvueUi.modal.show({
        component: ImageUploaderCropper,
        width: this.width * 2,
        height: this.height * 2,
        backgroundColor: 'rgba(255,255,255,0.85)',
        data: {
          base64Image,
          width: this.width,
          height: this.height,
        },
      })
    },
  },
  created() {
    this.profile = {...this.value}
  },
  watch: {
    profile(newValue, oldValue) {
      this.$emit('input', this.profile)
    }
  },
}
</script>

<style scoped lang="scss">
@import '@/style/_variables.scss';
h4 {
  font-size: 1rem;
}

.avatarBox {
  width: 80px;
  height: 80px;
  border-radius: 100%;
  padding: 2px;
  background-color: $bg-grey;
  img.avatar {
    background-color: $bg-grey;
    width: 76px;
    height: 76px;
    border-radius: 100%;
  }
}

.file {
  width: 80px;
  height: 80px;
  top: 0;
  opacity: 0;
}

.labelprofile {
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/ProfileEditor.vue